import React from 'react';
import MyInquiryTable from './MyInquiryTable';
import MyReceivedInquiryBidsTable from './MyReceivedInquiryBidsTable';
import Box from '@material-ui/core/Box';
import { makeStyles } from '@material-ui/core/styles';

const useStyles = makeStyles(theme => ({
  table: {
    marginBottom: theme.spacing(5)
  }
}))
export default function MyInquiriesPage() {
  const classes = useStyles();
  return (
    <Box>
      <Box className={classes.table}>
        <MyInquiryTable />
      </Box>
      <Box className={classes.table}>
        <MyReceivedInquiryBidsTable />
      </Box>
    </Box>
  )
}
